import { render, staticRenderFns } from "./icon-button.vue?vue&type=template&id=030e3f0f&scoped=true"
import script from "./icon-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./icon-button.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./icon-button.vue?vue&type=style&index=0&id=030e3f0f&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030e3f0f",
  null
  
)

export default component.exports